type IconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const ClimateIcon = ({ size = 18, color = 'currentColor', className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <line x1="12" y1="2" x2="12" y2="22" />
    <line x1="4.93" y1="4.93" x2="12" y2="12" />
    <line x1="19.07" y1="4.93" x2="12" y2="12" />
    <line x1="2" y1="12" x2="12" y2="12" />
    <line x1="22" y1="12" x2="12" y2="12" />
    <line x1="4.93" y1="19.07" x2="12" y2="12" />
    <line x1="19.07" y1="19.07" x2="12" y2="12" />
  </svg>
);
